/**
 * TODO @Michael: Update. This is all out of date.
 *
 * The expandable component is used to create areas of content that can be expanded or collapsed
 * to hide or show content in the area. This uses aria to make the content accessible.
 * The state is controlled by its label (indicated by `aria-labelledby`).
 * The label should point back at the expandable area using `aria-controls`.
 * An expandable area my have multiple controls and a control may control multiple areas.
 * The "expandable" style class goes on the area which expands..
 *
 * Note: The British spelling with double "l" in: aria-labelledby
 *
 * You may exclude the `aria-controls` and `aria-expanded` attributes off your markup and the javascript code
 * will add it based on if the associated expandable area is marked as expanded or not.
 * Excluding `aria-controls` and `aria-expanded` is recommended.
 *
 * There is also an optional "data-expandable-groupName" attribute you can add to put an expandable in a group.
 * Without this any Expandable instances that are siblings in the DOM are considered siblings to this.
 * By default that just affects things like up and down arrow use, and expand and collapse sibling behaviour.
 *
 * Use the optional "data-expandable-key" attribute to give your instance an ID which will be used to remember
 * the state of the expandable area if the the component is rerendered during AJAX. Make sure it is
 * unique across the entire page.
 *
 * @example
 * Simple example (Note: This includes "aria-expanded" and "aria-controls" which is not recommended.):
 * ```html
 * <button id="control1" aria-controls="section1" aria-expanded="false">This is closed</button>
 * <div id="section1" aria-labelledby="control1" class="expandable">
 * 	...
 * </div>
 * <button id="control1" aria-controls="section1" aria-expanded="true">This is open</button>
 * <div id="section1" aria-labelledby="control1" class="expandable expandableArea--isExpanded">
 * 	...
 * </div>
 * ```
 * @example
 * If you don't want to use a "button", anchor similar, use tabindex="0" to make it so the control can be given focus.
 * You can also exclude the aria-expanded and aria-controls attributes.
 * ```html
 * <h2 id="control1" tabindex="0">Header</h2>
 * <div id="section1" aria-labelledby="control1" class="expandable">
 * 	...
 * </div>
 * ```
 * @example
 * Example with multiple controls:
 * ```html
 * <button id="control1">Header</button>
 * <button id="control2">A second control to same area</button>
 * <div id="section1" aria-labelledby="control1 control2" class="expandable">
 * 	...
 * </div>
 * ```
 * @example
 * When used with JSF, you will need to determine the client IDs for each element. Here
 * is an example using JSF's HTML5 friendly markup but a JSF component would also work.
 * Please note that both the control and expandable section need IDs unique in the document.
 * The `p:clientId` calls is a Plaudit function that looks up the client side ID based
 * on the ID in the current context. You will need to set these namespaces:
 * xmlns:jsf="http://xmlns.jcp.org/jsf"
 * xmlns:p="http://jsf.plaudit.com/commons"
 * ```html
 * <button jsf:id="control1">Header</button>
 * <div jsf:id="section1" aria-labelledby="#{p:clientId('control1')}" class="expandable #{isExpanded ? 'expandableArea--isExpanded' : ''}">
 * 	...
 * </div>
 * ```
 *
 * TODO @Michael: Document optional style classes.
 * TODO @Michael: Document events.
 */

import ExpandableArea from "./ExpandableArea";
import ExpandableControl from "./ExpandableControl";
import ExpandableManager from "./ExpandableManager";

export {ExpandableArea, ExpandableControl, ExpandableManager};